import R from 'ramda'
import log from './utils/log'
import getLocaleFromUrl from './utils/getLocaleFromUrl'
import {togglePath, unionWithId, assocPathArray} from './utils/objUtils'
import getLeafGeographicalZoneIds from './utils/getLeafGeographicalZoneIds'

const initialState = {
  viewPort: {
    topLeft: {lat: 42.956, lng: -64.006},
    bottomRight: {lat: 52.160, lng: -79.607}
  },
  zoom: 0,
  defaultViewPort: {
    topLeft: {lat: 42.956, lng: -64.006},
    bottomRight: {lat: 52.160, lng: -79.607}
  },
  options: {
    transportationTypes: [],
    travelDurations: [
      {label: "5 min", value: 5},
      {label: "10 min", value: 10},
      {label: "15 min", value: 15},
      {label: "20 min", value: 20},
      {label: "25 min", value: 25},
      {label: "30 min", value: 30},
      {label: "35 min", value: 35},
      {label: "40 min", value: 40},
      {label: "45 min", value: 45},
      {label: "50 min", value: 50},
      {label: "55 min", value: 55},
      {label: "1 h",    value: 60},
      {label: "1 h 15",  value: 75},
      {label: "1 h 30",  value: 90},
      {label: "1 h 45",  value: 105},
      {label: "2 h",    value: 120},
      {label: "2 h 15",    value: 135},
      {label: "2 h 30",    value: 150},
      {label: "2 h 45",    value: 165},
      {label: "3 h",    value: 180},
    ],
    langs: [
      {label:"Français", value:"fr"},
      {label:"English", value:"en"},
    ],
    areaUnits:[
      {name: 'm2', fromMeter: i => i, toMeter: i => i},
      {name: 'ft2', fromMeter: i =>  R.memoize(Math.round(i * 10.76391)), toMeter: R.memoize(i => Math.round(i/10.76391))},
    ],
    distanceUnits:[],
    currencies: [{name:"CAD", id:"CAD"}],
    sort: [
      {
        fieldName: 'price',
        asc: true,
        name: 'priceasc'
      },
      {
        fieldName: 'price',
        name: 'pricedesc',
        asc: false,
      },
      {
        name: 'proximity',
        fieldName: 'proximityScore',
        asc: true,
      },
      {
        name: 'date',
        fieldName: 'firstImported',
        asc: false,
      },
      {
        name: 'pertinence',
        fieldName: 'pertinenceScore',
        asc: false,
      }
    ],
    provinces: [],
    regions: [],
    towns: [],
    estateTypes: [],
    partners: [],
  },

  estates: {},  //ids to {summary: true|false, details: true|false, data: {...}}
  estateList: [], //search results for the list (index + score on each sorting options)
  estateMap: [], //list {id:42, coordinates: {lat:42,lng:42}}
  estateGroupsMap: [], //list {ids: [42], coordinates:{lat:42, lng: 42}}
  estateListIdsIndex: {}, //ids to true, if estate is in list (id only)
  lastVisibleIndex: 20,
  boundaries: [],
  pathsBetweenPoisAndEstate: [],
  suggestions: [],
  address:"",  
  queryMetaData: {
    nbResults: 0,
    nbLikes: 0,
    time: 0,
    nbZones: 0,
  },

  lang: getLocaleFromUrl(),
  areaUnit: "ft2",
  distanceUnit: "1",
  currency: "CAD",
  sort: {
    name: 'pertinence'
  },
  savedList: "",
  savedQueries: [],
  newQueryName: "",
  selectedEstateId: null,
  
  searchingPoi: false,
  poiOptions: [],

  serviceIds: [], //Ids of service to fetch
  services: [], //fetched services

  show: {
    searchForm: false,
    list: false,
    map: false,
    moreOptions: false,
    suggestions: true,
    estateList: false,
    preferencesModal: false,
    boundaries: false,
    myQueries: false,
    loadingEstates: false,
    loginRequiredModal: false,
    userDropdown: false,
    annonceDropdown: false,
    languageDropdown: false,
  },
  session: {
    userName: "",
    token: "",
  },
  completedTours: {
    search: false,
    preSearch: false
  },
  notifications: [],

  more: false,

  map: {}
}
const toInt = s => parseFloat(s, 10)

const toggleMore = (state, action) => {
  if(state.more)
    return R.assoc('more', false, state)
  else
    return R.assoc('more', true, state)
}

const togglePreferencesModal = togglePath(['show','preferencesModal'])
const toggleMoreOptions = togglePath(['show', 'moreOptions'])
const toggleSuggestions  = togglePath(['show', 'suggestions'])
const toggleEstateList = togglePath(['show', 'estateList'])
const showEstateList = R.assocPath(['show', 'estateList'], true)
const toggleMyQueriesModal = togglePath(['show', 'myQueries'])
const toggleLoadingEstates = togglePath(['show', 'loadingEstates'])
const toggleLoginRequiredModal = togglePath(['show', 'loginRequiredModal'])
const toggleAnnonceDropdown = togglePath(['show', 'annonceDropdown'])
const toggleLanguageDropdown = togglePath(['show', 'languageDropdown'])
const toggleUserDropdown = togglePath(['show', 'userDropdown'])
const toggleSearchingPoi = (state, action) => R.evolve({searchingPoi: action.value ? R.T : R.F}, state)

const loadControlTable = (state, action) => {
  const tr = {
    defaultViewPort: R.always(R.evolve({topLeft:{lat:toInt, lng: toInt}, bottomRight: {lat: toInt, lng: toInt}},action.payload.defaultViewPort)),
    options: {
      distanceUnits: R.always(action.payload.distances),
      provinces: R.always(action.payload.states),
      regions: R.always(action.payload.regions),
      towns: R.always(action.payload.towns),
      estateTypes: R.always(action.payload.estateTypes),
      transportationTypes: R.always(action.payload.transportationTypes),
      partners: R.always(action.payload.partnerNames),
    }
  }
  return R.evolve(tr, state)
}

const change = (state, action) => R.assoc(action.field, action.value, state)


const saveResponseMetaData = (state, action) => {
  const metaDataFields = ["nbTowns", "nbTypes", "nbResults", "nbLikes", "time", "sort", "savedList"]
  const newMetaData = {
      ...R.pick(metaDataFields, action.payload),
      nbZones: R.length(getLeafGeographicalZoneIds(state))
  }

  return R.evolve({queryMetaData: R.flip(R.merge)(newMetaData)}, state)
}


const updateSuggestions = (state, action) => R.assoc('suggestions', action.payload, state)


const flipEstateCard = (state, action) => {
  const currentSelectedEstateId = state.selectedEstateId
  const newSelectedEstateId = state.selectedEstateId == action.estateId ? null : action.estateId
  return R.assoc('selectedEstateId', newSelectedEstateId, state)
}

const setMap = (state,action) => {
  return R.assoc('map', action.map, state)
}

const showDirections = (state, action) => {
  const currentSelectedEstateId = state.selectedEstateId
  const newSelectedEstateId = state.selectedEstateId == action.estateId ? null : action.estateId
  return R.assoc('selectedEstateId', newSelectedEstateId, state)
}


const updateViewPort = (state, action) => {
  var testVar= R.evolve({
    viewPort: R.always(action.bounds),
    zoom: R.always(action.zoom)
  }, state)
  return testVar
}

const changeSort = (state, action) => {
      
  return R.evolve({
    sort: {
      name: R.always(action.name),
    }
  }, state)
}

const loadEstates = (state, action) => {
  const normalizeEstate = (estate) => {
    const currentEstate = R.path(['estates', estate.id, 'data'], state)    
    return {summary: true, data: R.merge(currentEstate, estate)}
  }
  const estatesById = estates => R.mapObjIndexed(normalizeEstate, R.indexBy(R.prop('id'), estates))
  const tr = {
    estates: R.mergeWith(R.mergeWith(R.merge), estatesById(action.estates))
  }
  return R.evolve(tr, state)
}

const changeEstatesInList = (state, action) => {
  var tempsDebut = Date.now()
  const ids = R.pluck('id', action.matchs)

  // The next line is too slow. It was replaced by the following three lines.
  //const estateListIdsIndex = R.reduce((acc, id) => R.assoc(id, true, acc), {}, ids)

  var estateListIdsIndex = {};
  for(var i=0; i<ids.length; i++)
    estateListIdsIndex[ids[i]] = true;

  return R.evolve({
    estateList: R.always(action.matchs),
    estateListIdsIndex: R.always(estateListIdsIndex),
  }, state)
}

const loadEstateMap = (state, action) => {
  return R.evolve({
    estateMap: R.always(action.estates)
  }, state)
}

const mergeEstateInfo = (state, action) => {
  const path = ['estates', action.estateId]
  const oldRecord = R.path(path, state)
  const newRecord = {
    details: true,
    data: action.details
  }
  const newEstate = R.mergeWith(R.merge, oldRecord, newRecord) 
  return R.assocPath(path, newEstate, state)
}

const toggleEstateMarker = (state, action) => {
  return togglePath(['estates', action.estateId, 'data', 'showPopup'])(state)
}

const changeMapMarker = (state, action) => {
  return R.evolve({
    estateMap: R.always(action.estates), 
    estateGroupsMap: R.always(action.groups)
  }, state)
}

const loadBoundaries = (state, action) => {
  return R.evolve({
    boundaries: R.always(action.boundaries),
    show: R.assoc('boundaries', true)
  }, state)
}
const hideBoundaries = (state, action) => {
  return R.evolve({
    show: R.assoc('boundaries', false),
  }, state)
}

const likeEstate = (state, action) => {
  const op = action.like ? R.inc : R.dec
  const tmpState = R.assocPath(['queryMetaData', 'nbLikes'], op(state.queryMetaData.nbLikes), state)
  return R.assocPath(['estates', action.estateId, 'data', 'like'], action.like, tmpState)
}

const likeEstates = (state, action) => {
  const tmpState = R.assocPath(['queryMetaData', 'nbLikes'], R.length(action.estateToMarkAsLiked), state)
  const fn = (state, likedEstateId) => {
     return R.assocPath(['estates', likedEstateId, 'data', 'like'], true, state)
  }
  return R.reduce(fn, tmpState, action.estateToMarkAsLiked)

}

const changeNewQueryName = (state, action) => {
  return R.assoc('newQueryName', action.name, state)
}

const loadQueries = (state, action) => {
  return R.assoc('savedQueries', action.queries, state)
}

const resetNewQueryName = (state, action) => {
  return R.assoc('newQueryName', '', state)
}
const restoreToken = (state, action) => {
  return R.evolve({
    session: {
      userName: R.always(action.userName),
      token: R.always(action.token),
    }
  }, state)
}

const logout = (state, action) => {
  return R.assoc('session', initialState.session, state)
}

const loadPaths = (state, action) => {
  return R.assoc("pathsBetweenPoisAndEstate", action.paths, state)
}

const erasePaths = (state, action) => {
  var newState = R.assoc("pathsBetweenPoisAndEstate", [], state);
  newState = R.assoc("selectedEstateId", null, newState);
  
  return newState;
}

const setServicesIds = (state, action) => {
  const serviceIds = action.serviceIds
  return R.evolve({
    serviceIds: _ => serviceIds,
  }, state)
  
}

const loadServices = (state, action) => {
  return R.assoc('services', action.services, state)
}

const loadPoiOptions = (state, action) => {
  state['poiOptions'] = action.options; 
  return state;
}
const poiSearchChange = (state, action) => {
  return R.assoc('address', action.address, state)
}

const saveCompletedTours = (state, action) => {
  return R.assoc('completedTours', action.completedTours, state)
}

const accountCreated = (state, action) => R.assocPath(['session', 'accountCreated'], true, state)

const lastVisibleIndexChanged = (state, {newLastVisibleIndex}) => R.assoc('lastVisibleIndex', newLastVisibleIndex, state)

const addEstateToVisibleList = (state, action) => {
  const {lastVisibleIndex, estateList} = state
  const estateInList = R.find((estate) => estate.id == action.estateId, estateList)
  const estateWithSortIgnored =  R.merge(estateInList, {id: action.estateId, ignoreSort: true, key: new Date().getTime(), proximityScore: 0})

  return R.evolve({
    lastVisibleIndex: R.inc(lastVisibleIndex),
    estateList: R.prepend(estateWithSortIgnored),
  }, state)
}

const addNotification = (state, action) => R.evolve({notifications: R.append(action.notification)}, state)
const deleteNotification = (state, action) => R.evolve({notifications: R.reject(R.propEq('id', action.notificationId))}, state)



const reducer = (state = initialState, action)  =>
  R.cond([
    [R.equals("set_map"),                         _ => setMap(state,action)],
    [R.equals("show_directions"),                 _ => showDirections(state,action)],
    [R.equals("toggle_more"),                     _ => toggleMore(state, action)],
    [R.equals("preferences_toggle"),              _ => togglePreferencesModal(state, action)],
    [R.equals("preferences_change"),              _ => change(state, action)],
    [R.equals("control_tables"),                  _ => loadControlTable(state, action)],
    [R.equals("load_estates"),                    _ => loadEstates(state, action)],
    [R.equals("change_estates_to_show_in_list"),  _ => changeEstatesInList(state, action)],
    [R.equals("update_know_summaries"),           _ => updateKnowSummaries(state, action)],
    [R.equals("load_estate_map"),                 _ => loadEstateMap(state, action)],
    [R.equals("search_results"),                  _ => saveResponseMetaData(state, action)],
    [R.equals("toggle_more_options"),             _ => toggleMoreOptions(state, action)],
    [R.equals("toggle_suggestions"),              _ => toggleSuggestions(state, action)],
    [R.equals("toggle_estate_list"),              _ => toggleEstateList(state, action)],
    [R.equals("show_estate_list"),                _ => showEstateList(state, action)],
    [R.equals("update_suggestions"),              _ => updateSuggestions(state, action)],
    [R.equals("flip_estate_card"),                _ => flipEstateCard(state, action)],
    [R.equals("load_estate_details"),             _ => mergeEstateInfo(state, action)],
    [R.equals("update_view_port"),                _ => updateViewPort(state, action)],
    [R.equals("change_sort"),                     _ => changeSort(state, action)],
    [R.equals("toggle_estate_marker"),            _ => toggleEstateMarker(state, action)],
    [R.equals("change_map_markers"),              _ => changeMapMarker(state, action)],
    [R.equals("show_boundaries"),                 _ => loadBoundaries(state, action)],
    [R.equals("hide_boundaries"),                 _ => hideBoundaries(state, action)],
    [R.equals("like_estate"),                     _ => likeEstate(state, action)],
    [R.equals("like_estates"),                    _ => likeEstates(state, action)],
    [R.equals("toggle_my_queries_modal"),         _ => toggleMyQueriesModal(state, action)],
    [R.equals("toggle_loading_estates"),          _ => toggleLoadingEstates(state, action)],
    [R.equals("change_new_query_name"),           _ => changeNewQueryName(state, action)],
    [R.equals("load_queries"),                    _ => loadQueries(state, action)],
    [R.equals("reset_new_query_name"),            _ => resetNewQueryName(state, action)],
    [R.equals("restore_token"),                   _ => restoreToken(state, action)],
    [R.equals("erase_paths"),                     _ => erasePaths(state, action)],
    [R.equals("load_paths"),                      _ => loadPaths(state, action)],
    [R.equals("set_service_ids"),                 _ => setServicesIds(state, action)],
    [R.equals("load_services"),                   _ => loadServices(state, action)],
    [R.equals("toggle_login_required_modal"),     _ => toggleLoginRequiredModal(state, action)],
    [R.equals("toggle_searching_poi"),            _ => toggleSearchingPoi(state, action)],
    [R.equals("load_poi_options"),                _ => loadPoiOptions(state, action)],
    [R.equals("poi_search_change"),               _ => poiSearchChange(state, action)],
    [R.equals("toggle_annonce_dropdown"),         _ => toggleAnnonceDropdown(state, action)],
    [R.equals("toggle_user_dropdown"),            _ => toggleUserDropdown(state, action)],
    [R.equals("toggle_language_dropdown"),        _ => toggleLanguageDropdown(state, action)],
    [R.equals("save_completed_tours"),            _ => saveCompletedTours(state, action)],
    [R.equals("account_created"),                 _ => accountCreated(state, action)],
    [R.equals("last_visible_index_changed"),      _ => lastVisibleIndexChanged(state, action)],
    [R.equals("add_estate_to_visible_list"),      _ => addEstateToVisibleList(state, action)],
    [R.equals("add_notification"),                _ => addNotification(state, action)],
    [R.equals("delete_notification"),             _ => deleteNotification(state, action)],
    [R.T, _ => defaultProcessing(state, action)],
  ])(action.type)

const defaultProcessing = (state, action) => {
  if(process.env.NODE_ENV !== "production") {
    if(action.type.indexOf("@@") == -1) {
      console.error(`Action of type ${action.type} is being ignored`)
    }
  }
  return state
}
const reducerEnhancer = (reducerToEnhance) => (state, action) => {
  const nextState = reducerToEnhance(state, action)
  if(process.env.NODE_ENV !== 'production' && (typeof nextState) == "function"){
    console.error(`Reducer retuned a function (instead of an object) for the action type: ${action.type}`)
  }
  return nextState
}
export default reducerEnhancer(reducer)



/** WEBPACK FOOTER **
 ** ./app/reducer.js
 **/